module.exports = __webpack_public_path__ + "img/Flag_of_Ecuador.df3a0094.svg";